/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { memo } from "react";
import cx from "classnames";
import { AppImage } from "../AppImage/AppImage";

import styles from "./ImageWithPlaceholder.module.scss";

export interface Props {
  src?: string; // source for the image which will be rendered once it is loaded
  alt?: string;
  className?: string;
  isLCP?: boolean;
}

/*
 * Component which will display given image based od imageSrc. Until image is not loaded (ready to be rendered)
 * a placeholder image will be rendered
 */
const ImageWithPlaceholder = ({ src, alt, className, isLCP }: Props) => {
  if (!src) {
    return null;
  }

  return (
    <AppImage
      className={cx(styles.image, className)}
      src={src}
      draggable={false}
      priority={isLCP}
      fill={true}
      sizes="100vw"
      alt={alt || ""}
    />
  );
};

export default memo(ImageWithPlaceholder);
